import React, {Fragment} from 'react'
import {formatTime} from 'admin/lib/format'
import Details from './Details'

const EVENT_MAP = {
  create: 'Created',
  destroy: 'Deleted',
  restore: 'Restored'
}

export default ({history}) => {
  return (
    <Fragment>
      {history.map((version, i) => {
        return (
          <Fragment key={i}>
            <p style={{lineHeight: '1.3em'}} className='mb-2 is-size-7'>
              <span className='has-text-weight-semibold'>{version.user || 'System'}</span>
              &nbsp;&nbsp;&#8226;&nbsp;&nbsp;
              {formatTime(version.timestamp)}
            </p>
            <div
              className={`notification m-0 p-3 is-size-7 ${version.notes?.length && version.user ? 'has-background-info-light' : ''}`}>
              {!['associate', 'update'].includes(version.event) ? (
                <Fragment>
                  {EVENT_MAP[version.event]}
                  <br />
                </Fragment>
              ) : null}
              {version.notes?.length ? (
                <Fragment>
                  <span className={version.user ? 'has-text-info has-text-weight-semibold' : ''}>{version.notes}</span>
                  <br />
                </Fragment>
              ) : null}
              <Details details={version.details} />
            </div>
          </Fragment>
        )
      })}
    </Fragment>
  )
}
